import { StyledText } from './styles';
import { TextProps } from './types';

export const Text = ({
  className = '',
  children,
  color,
  html = '',
  size = 'xs',
  weight = 'regular',
}: TextProps) => {
  if (html) {
    return (
      <StyledText
        className={className}
        color={color}
        dangerouslySetInnerHTML={{ __html: html }}
        size={size}
        weight={weight}
      />
    );
  }

  return (
    <StyledText
      className={className}
      color={color}
      size={size}
      weight={weight}
    >
      {children}
    </StyledText>
  );
};
